import { cn } from '@/shared/lib/utils'

export function ComplianceSubPageHeader({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <header
      className={cn(
        'mb-4 flex shrink-0 flex-col gap-4 sm:flex-row sm:items-center sm:justify-between',
        className
      )}
    >
      {children}
    </header>
  )
}
